<template>
  <div>
    <viewer
      v-if="previewSrcList.length"
      ref="viewer"
      :images="previewSrcList"
      @inited="inited"
    >
      <img
        v-for="(item, index) in previewSrcList"
        v-show="false"
        :key="index"
        :src="item"
      />
    </viewer>
    <slot />
  </div>
</template>

<script>
import Vue from 'vue';
import Viewer from 'v-viewer';
import '../css/viewer.css';

Vue.use(Viewer);
export default {
  name: 'ViewerImage',
  props: {
    // 当前图片地址
    src: {
      type: String,
      default: '',
    },
    // 所有图片地址数组
    previewSrcList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      $viewer: null,
      showViewer: false,
      activeIndex: 0,
    };
  },
  computed: {
    imageIndex() {
      let previewIndex = 0;
      const srcIndex = this.previewSrcList.indexOf(this.src);
      if (srcIndex >= 0) {
        previewIndex = srcIndex;
      }
      return previewIndex;
    },
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
      this.$viewer.index = this.imageIndex;
      // 不要他的按钮
      // this.$viewer.options.button = false
      // 不要他的底部缩略图
      this.$viewer.options.navbar = false;
      // 不要他的底部标题
      this.$viewer.options.title = false;
    },
    /**
     * 获取文件后缀
     * @returns {string}
     */
    getSuffix() {
      let url = '';
      if (this.previewSrcList[this.imageIndex].substr(0, 4) === 'http') {
        url = this.previewSrcList[this.imageIndex].split('?')[0];
      }
      return url.substr(url.lastIndexOf('.') + 1).toLowerCase();
    },
    /**
     * 预览图片
     */
    show() {
      setTimeout(() => {
        if (!this.previewSrcList[this.imageIndex]) return;
        if (this.getSuffix() === 'pdf') {
          // 弹出窗口的宽度;
          const iWidth = 900;
          // 弹出窗口的高度;
          const iHeight = 600;
          // 获得窗口的垂直位置
          const iTop = (window.screen.availHeight - 30 - iHeight) / 2;
          // 获得窗口的水平位置
          const iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
          window.open(
            this.previewSrcList[this.imageIndex],
            '',
            `height=${iHeight},,innerHeight=${iHeight},width=${iWidth},innerWidth=${iWidth},top=${iTop},left=${iLeft},status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no`
          );
        } else {
          this.$viewer.show();
        }
      }, 0);
    },
  },
};
</script>
<style scoped></style>
